import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { IoMdSave } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { CgCalendarDates } from "react-icons/cg";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaSitemap, FaSyncAlt, FaEdit } from "react-icons/fa";
import Modal from './Modal';
import axios from "axios";
const API_URL = process.env.REACT_APP_API_BASE || '';

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

// ─── Fetch phone numbers for the logged-in user ───────────────────────────────
async function fetchPhoneNumbers() {
    const{userId,token} = getUserIdFromToken();
    try {
        const headers = token ? { Authorization: token } : {};
        // Use axios to fetch phone numbers, since the response is already JSON
        const response = await axios.get(`${API_URL}/auth/my-whatsapp`, { headers });

        // According to your provided response the data is inside response.data
        const data = response.data;
        return Array.isArray(data) ? data : [];
    } catch {
        return [];
    }
}

function Chatbot() {
  const [search, setSearch]           = useState('');
  const [open, setOpen]               = useState(false);
  const [isEdit, setIsEdit]           = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading]         = useState(false);
  const [saving, setSaving]           = useState(false);
  const [deleting, setDeleting]       = useState(null);
  const [error, setError]             = useState('');
  const [flows, setFlows]             = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);

  // Form state for Add
  const [newName, setNewName]             = useState('');
  const [newPhoneId, setNewPhoneId]       = useState('');
  const [newIsActive, setNewIsActive]     = useState(false);

  // Form state for Edit
  const [editName, setEditName]           = useState('');
  const [editPhoneId, setEditPhoneId]     = useState('');
  const [editIsActive, setEditIsActive]   = useState(false);

  const itemsPerPage = 6;
 const { token } = getUserIdFromToken();
  // ── Load flows ──────────────────────────────────────────────────────────────
  const fetchFlows = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      // Send token as authorization header, per authMiddleware requirement
     
      const res = await fetch(`${API_URL}/auth/chatbot/flows`, {
        method: 'GET',
        credentials: 'include',
        headers: token ? { Authorization: token } : {},
      });
      const json = await res.json();
      if (json.success) setFlows(json.data || []);
      else setError('Failed to load flows');
    } catch (e ) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFlows();
    fetchPhoneNumbers().then(setPhoneNumbers);
  }, [fetchFlows]);
  // console.log("setPhoneNumbers ",phoneNumbers);

  // ── Filter + paginate ───────────────────────────────────────────────────────
  const filtered       = flows.filter(f =>
    f.name?.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages     = Math.ceil(filtered.length / itemsPerPage);
  const indexOfLast    = currentPage * itemsPerPage;
  const indexOfFirst   = indexOfLast - itemsPerPage;
  const currentData    = filtered.slice(indexOfFirst, indexOfLast);

  // ── Toggle active ───────────────────────────────────────────────────────────
  // Updated to call correct API path and method per backend (PATCH, not GET)
  // Notice: The CORS error you are encountering is because the backend server is not allowing PATCH in the Access-Control-Allow-Methods header during the preflight OPTIONS request.
  // This cannot be solved from the frontend alone; the backend must be updated to allow PATCH.
  //
  // However, as a workaround, you can send your PATCH as a POST request with an override,
  // and have the backend interpret it accordingly (the backend must be changed to support this for production).
  // See: https://stackoverflow.com/questions/32563939/how-to-overcome-cors-issue-in-reactjs
  //
  // If the backend accepts ?_method=PATCH or similar, you may use that. Otherwise, you could risk updating your code to POST as below.

  const toggleActive = async (flow) => {
    try {
      // Use PATCH method as required by backend API
      const res = await fetch(`${API_URL}/auth/chatbot/flow/${flow.id}/toggle`, {
        method: 'PATCH',
        credentials: 'include',
        headers: {
          ...(token ? { Authorization: token } : {}),
        },
      });

      if (res.status === 404) {
        setError('Bot flow not found.');
        return;
      }

      const json = await res.json();
      if (json.success) {
        setFlows(prev =>
          prev.map(f => f.id === flow.id ? { ...f, is_active: json.is_active } : f)
        );
      } else if (json.error) {
        setError(json.error);
      } else {
        setError('Failed to toggle flow activity.');
      }
    } catch (e) {
      setError(e.message);
    }
  };

  // ── Add flow ────────────────────────────────────────────────────────────────
  const handleAdd = async () => {
    if (!newName.trim()) { setError('Bot name is required'); return; }
    if (!newPhoneId)     { setError('Channel number is required'); return; }
    setSaving(true);
    setError('');
    try {
      const res  = await fetch(`${API_URL}/auth/chatbot/flow`, {
        method:  'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...(token ? { Authorization: token } : {})
        },
        credentials: 'include',
        body: JSON.stringify({ name: newName, phone_number_id: newPhoneId, is_active: newIsActive }),
      });
 
      const json = await res.json();
      if (json.success) {
        setOpen(false);
        setNewName(''); setNewPhoneId(''); setNewIsActive(false);
        fetchFlows();
      } else {
        setError(json.error || 'Failed to create');
      }
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  // ── Open edit modal ─────────────────────────────────────────────────────────
  const openEdit = (flow) => {
    setSelectedItem(flow);
    setEditName(flow.name);
    setEditPhoneId(flow.phone_number_id);
    setEditIsActive(!!flow.is_active);
    setIsEdit(true);
    setError('');
  };

  // ── Save edit ───────────────────────────────────────────────────────────────
  const handleEdit = async () => {
    if (!editName.trim()) { setError('Bot name is required'); return; }
    setSaving(true);
    setError('');
    try {
      const res  = await fetch(`${API_URL}/auth/chatbot/flow/${selectedItem.id}`, {
        method:  'PUT',
        headers: token ? { Authorization: token } : {},
        credentials: 'include',
        body: JSON.stringify({ name: editName, phone_number_id: editPhoneId, is_active: editIsActive }),
      });
      const json = await res.json();
      if (json.success) {
        setIsEdit(false);
        fetchFlows();
      } else {
        setError(json.error || 'Failed to update');
      }
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  // ── Delete flow ─────────────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this chatbot flow? This cannot be undone.')) return;
    setDeleting(id);
    try {
      await fetch(`${API_URL}/auth/chatbot/flow/${id}`, {
        method: 'DELETE', credentials: 'include',headers: token ? { Authorization: token } : {},
      });
      setFlows(prev => prev.filter(f => f.id !== id));
    } catch (e) { setError(e.message); }
    finally { setDeleting(null); }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <div className='dark:bg-[#121519] pl-4 pr-4'>
        {/* Header */}
        <div className='border-b border-[#cfcdcd] pb-2 w-full'>
          <h1 className='text-black font-semibold text-[20px] dark:text-white flex items-center gap-2'>
            <Link to='/Automation'><FaArrowLeftLong /></Link>
            WhatsApp Chatbot Flows
          </h1>
          <div className='text-[#454546] dark:text-white text-[12px] font-semibold flex items-center cursor-pointer'>
            <Link to='/'>Home</Link>
            <IoIosArrowForward />
            <span>WhatsApp</span>
            <IoIosArrowForward />
            <span>WhatsApp Chatbot Flows</span>
          </div>
        </div>

        {/* Controls */}
        <div className='flex flex-wrap w-full mt-4 gap-2 items-end'>
          <button
            onClick={() => { setOpen(true); setError(''); setNewName(''); setNewPhoneId(''); setNewIsActive(false); }}
            className='hover:bg-[#448c74] hover:text-white border border-[#448c74] text-[12px] flex items-center py-2 text-[#448c74] px-4 rounded-md font-semibold gap-1 transition-colors'
          >
            <MdAdd className='text-[16px] font-bold' />
            Add Chatbot Flow
          </button>

          <div className='flex items-center gap-2 ml-auto'>
            <div className='flex flex-col gap-1'>
              <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Search</label>
              <input
                value={search}
                onChange={e => { setSearch(e.target.value); setCurrentPage(1); }}
                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white w-48'
                type="text" placeholder="Search flows..."
              />
            </div>
            <button
              onClick={fetchFlows}
              className='flex items-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors mt-4'
            >
              <TbReload /><span className='text-[12px] font-bold'>Refresh</span>
            </button>
          </div>
        </div>

        {/* Error */}
        {error && (
          <div className='w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded mt-3'>
            {error}
          </div>
        )}

        {/* Stats */}
        <div className='flex gap-4 mt-3'>
          <span className='text-[11px] text-gray-500'>
            Total: <span className='font-bold text-[#37715d]'>{flows.length}</span>
          </span>
          <span className='text-[11px] text-gray-500'>
            Active: <span className='font-bold text-green-600'>{flows.filter(f => f.is_active).length}</span>
          </span>
          <span className='text-[11px] text-gray-500'>
            Inactive: <span className='font-bold text-gray-400'>{flows.filter(f => !f.is_active).length}</span>
          </span>
        </div>

        {/* Cards Grid */}
        <div className='w-full flex flex-wrap gap-4 mt-4'>
          {loading ? (
            <div className='w-full flex items-center justify-center py-16'>
              <div className='w-8 h-8 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin' />
              <span className='ml-3 text-[13px] text-gray-400'>Loading flows...</span>
            </div>
          ) : currentData.length === 0 ? (
            <div className='w-full flex flex-col items-center justify-center py-16 text-gray-400'>
              <div className='text-5xl mb-3'>🤖</div>
              <div className='text-[14px] font-semibold'>No chatbot flows yet</div>
              <div className='text-[12px] mt-1'>Click "Add Chatbot Flow" to get started</div>
            </div>
          ) : (
            currentData.map(item => (
              <div
                key={item.id}
                className='w-full sm:w-[48%] md:w-[30%] lg:w-[23%] xl:w-[18%] border border-[#e0e7ff] shadow-[0_4px_10px_rgba(0,0,0,0.04)] rounded-lg overflow-hidden hover:shadow-[0_6px_20px_rgba(0,0,0,0.08)] transition-shadow'
              >
                {/* Card Header */}
                <div className='w-full border-b border-[#e0e7ff] flex justify-between px-4 bg-[#f6f9fc] rounded-t-lg items-center pb-4 pt-3'>
                  <div>
                    <h6 className='text-black text-[14px] font-semibold dark:text-white'>{item.name}</h6>
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${item.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                      {item.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  {/* Toggle */}
                  <button
                    onClick={() => toggleActive(item)}
                    className={`w-[28px] h-[14px] flex items-center rounded-full transition duration-300 ${item.is_active ? 'bg-[#37715d]' : 'bg-[#b4bbc3]'}`}
                  >
                    <div className={`bg-white w-[11px] h-[11px] rounded-full shadow-md transform transition ml-[1.5px] ${item.is_active ? 'translate-x-[13px]' : ''}`} />
                  </button>
                </div>

                {/* Card Body */}
                <div className='px-4 py-4'>
                  <span className='flex items-center text-[12px] text-[#6c757d] font-semibold gap-2'>
                    <IoCall className='text-[#3fca90] text-[16px]' />
                    {item.display_phone_number || item['WABA Number'] || item.phone_number_id || '-'}
                  </span>
                  <span className='flex items-center text-[12px] text-[#6c757d] font-semibold gap-2 mt-3'>
                    <CgCalendarDates className='text-[#3fca90] text-[16px]' />
                    {item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '-'}
                  </span>
                </div>

                {/* Card Footer */}
                <div className='border-t border-[#e0e7ff] w-full flex justify-between px-4 py-2'>
                  <div className='flex items-center gap-2'>
                    {/* Open Flow Builder */}
                    <Link to={`/WAMessage/WAChatbotFlow/Index/${item.id}`}>
                      <div className='border-[#3fca90] border p-1 hover:bg-[#3fca90] text-[#3fca90] rounded-md group cursor-pointer' title='Open Flow Builder'>
                        <FaSitemap className='text-[#3fca90] group-hover:text-white text-[13px]' />
                      </div>
                    </Link>
                    {/* Sync */}
                    <div
                      onClick={fetchFlows}
                      className='border-[#3fca90] border p-1 hover:bg-[#3fca90] text-[#3fca90] rounded-md group cursor-pointer'
                      title='Refresh'
                    >
                      <FaSyncAlt className='text-[#3fca90] group-hover:text-white text-[13px]' />
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                    {/* Edit */}
                    <div
                      onClick={() => openEdit(item)}
                      className='border-[#3fca90] border p-1 hover:bg-[#3fca90] text-[#3fca90] rounded-md group cursor-pointer'
                      title='Edit flow'
                    >
                      <FaEdit className='text-[#3fca90] group-hover:text-white text-[13px]' />
                    </div>
                    {/* Delete */}
                    <div
                      onClick={() => handleDelete(item.id)}
                      className={`border-[#ed5050] border p-1 hover:bg-[#ed5050] text-[#ed5050] rounded-md group cursor-pointer ${deleting === item.id ? 'opacity-50 pointer-events-none' : ''}`}
                      title='Delete flow'
                    >
                      <RiDeleteBin5Line className='text-[#ed5050] group-hover:text-white text-[13px]' />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pagination */}
        {filtered.length > itemsPerPage && (
          <>
            <div className="flex justify-center mt-4 gap-2">
              <button
                onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded flex items-center gap-1 disabled:opacity-50 text-[12px]"
              >
                <IoIosArrowBack /> Prev
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 border rounded text-[12px] ${currentPage === i + 1 ? 'bg-[#37715d] text-white' : 'bg-white text-black'}`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded flex items-center gap-1 disabled:opacity-50 text-[12px]"
              >
                Next <IoIosArrowForward />
              </button>
            </div>
            <div className='w-full flex justify-center mt-2'>
              <p className='text-[#6c757d] text-[12px] font-semibold'>
                Showing {indexOfFirst + 1} to {Math.min(indexOfLast, filtered.length)} of {filtered.length} records
              </p>
            </div>
          </>
        )}
      </div>

      {/* ── Add Modal ──────────────────────────────────────────────────────────── */}
      <Modal isOpen={open} onClose={() => setOpen(false)} heading='Add Chatbot Flow'>
        <div className='py-2 border-y border-[#8b8a8a67] my-2 w-full'>
          {error && <div className='text-red-500 text-[11px] mb-2 bg-red-50 p-2 rounded'>{error}</div>}

          <div className='w-full flex flex-col gap-1 mt-2'>
            <label className='text-black text-[12px] font-semibold dark:text-white'>Bot Name *</label>
            <input
              type="text"
              className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
              placeholder='Enter bot name'
              value={newName}
              onChange={e => setNewName(e.target.value)}
            />
          </div>

          <div className='w-full flex flex-col gap-1 mt-3'>
            <label className='text-black text-[12px] font-semibold dark:text-white'>Channel Number *</label>
            <select
              value={newPhoneId}
              onChange={e => setNewPhoneId(e.target.value)}
              className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
            >
              <option value="">-- Select channel --</option>
              {phoneNumbers.map(p => (
                <option key={p.phone_number_id} value={p.phone_number_id}>
                  {p['WABA Number'] || p['Display Name'] || p.display_phone_number || p.phone_number_id}
                </option>
              ))}
            </select>
          </div>

          <div className='w-full flex items-center gap-2 mt-4'>
            <button
              onClick={() => setNewIsActive(!newIsActive)}
              className={`w-[28px] h-[14px] flex items-center rounded-full transition duration-300 ${newIsActive ? 'bg-[#37715d]' : 'bg-[#b4bbc3]'}`}
            >
              <div className={`bg-white w-[11px] h-[11px] rounded-full shadow-md transform transition ml-[1.5px] ${newIsActive ? 'translate-x-[13px]' : ''}`} />
            </button>
            <span
              onClick={() => setNewIsActive(!newIsActive)}
              className='text-[#454546] font-bold text-[13px] cursor-pointer'
            >
              Active
            </span>
          </div>
        </div>

        <div className='w-full flex justify-end gap-2'>
          <button
            onClick={handleAdd}
            disabled={saving}
            className='p-2 bg-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold text-white disabled:opacity-50'
          >
            <IoMdSave />
            {saving ? 'Saving…' : 'Add Flow'}
          </button>
          <button
            onClick={() => setOpen(false)}
            className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'
          >
            Cancel
          </button>
        </div>
      </Modal>

      {/* ── Edit Modal ─────────────────────────────────────────────────────────── */}
      <Modal isOpen={isEdit} onClose={() => setIsEdit(false)} heading='Edit Chatbot Flow'>
        <div className='py-2 border-y border-[#8b8a8a67] my-2 w-full'>
          {error && <div className='text-red-500 text-[11px] mb-2 bg-red-50 p-2 rounded'>{error}</div>}

          <div className='w-full flex flex-col gap-1 mt-2'>
            <label className='text-black text-[12px] font-semibold dark:text-white'>Bot Name *</label>
            <input
              type="text"
              className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
              placeholder='Enter bot name'
              value={editName}
              onChange={e => setEditName(e.target.value)}
            />
          </div>

          <div className='w-full flex flex-col gap-1 mt-3'>
            <label className='text-black text-[12px] font-semibold dark:text-white'>Channel Number *</label>
            <select
              value={editPhoneId}
              onChange={e => setEditPhoneId(e.target.value)}
              className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
            >
              <option value="">-- Select channel --</option>
              {phoneNumbers.map(p => (
                <option key={p.phone_number_id} value={p.phone_number_id}>
                  {p['WABA Number'] || p['Display Name'] || p.display_phone_number || p.phone_number_id}
                </option>
              ))}
            </select>
          </div>

          <div className='w-full flex items-center gap-2 mt-4'>
            <button
              onClick={() => setEditIsActive(!editIsActive)}
              className={`w-[28px] h-[14px] flex items-center rounded-full transition duration-300 ${editIsActive ? 'bg-[#37715d]' : 'bg-[#b4bbc3]'}`}
            >
              <div className={`bg-white w-[11px] h-[11px] rounded-full shadow-md transform transition ml-[1.5px] ${editIsActive ? 'translate-x-[13px]' : ''}`} />
            </button>
            <span
              onClick={() => setEditIsActive(!editIsActive)}
              className='text-[#454546] font-bold text-[13px] cursor-pointer'
            >
              Active
            </span>
          </div>
        </div>

        <div className='w-full flex justify-end gap-2'>
          <button
            onClick={handleEdit}
            disabled={saving}
            className='p-2 bg-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold text-white disabled:opacity-50'
          >
            <IoMdSave />
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
          <button
            onClick={() => setIsEdit(false)}
            className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}

export default Chatbot;